import Swal from 'sweetalert2';

const CustomAlert = {
  _injectStyles: () => {
    if (!document.getElementById('sweetalert-custom-common-styles')) {
      const style = document.createElement('style');
      style.id = 'sweetalert-custom-common-styles';
      style.innerHTML = `
        .swal-custom-popup.swal2-popup {
          border: 1px solid #1A192B !important;
          border-radius: 0px !important;
          padding: 15px !important;
          width: 530px !important;
          background-color: #fff !important;
        }
        .swal-custom-title.swal2-title {
          text-align: left !important;
          color: #002060 !important;
          font-family: 'Poppins', sans-serif !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          padding: 0 !important;
          margin: 0 0 15px 0 !important;
        }
        .swal-custom-content.swal2-html-container {
          text-align: left !important;
          color: #002060 !important;
          font-family: 'Poppins', sans-serif !important;
          font-size: 12px !important;
          margin: 0 0 30px 0 !important;
          padding: 0 !important;
        }
        .swal-custom-actions.swal2-actions {
          width: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
          justify-content: flex-end !important;
          display: flex !important;
          gap: 12px !important;
        }
        .swal-custom-confirm {
            font-size: 11px !important;
            background-color: #002060 !important;
            order: 2 !important;
            margin: 0 !important;
        }
        .swal-custom-cancel {
            font-size: 11px !important;
            background-color: #E9EEF5 !important;
            color: #002060 !important;
            order: 1 !important;
            margin: 0 !important;
        }
      `;
      document.head.appendChild(style);
    }
  },

  success: (title, text) => {
    CustomAlert._injectStyles();
    return Swal.fire({
      icon: false,
      title: title || 'Success',
      text: text || 'Operation completed successfully!',
      confirmButtonText: 'OK',
      customClass: {
        popup: 'swal-custom-popup',
        title: 'swal-custom-title',
        htmlContainer: 'swal-custom-content',
        actions: 'swal-custom-actions',
        confirmButton: 'swal-custom-confirm button_primary',
      },
    });
  },

  error: (title, text) => {
    CustomAlert._injectStyles();
    Swal.fire({
      icon: false,
      title: title || 'Error',
      text: text || 'Something went wrong!',
      confirmButtonText: 'OK',
      customClass: {
        popup: 'swal-custom-popup',
        title: 'swal-custom-title',
        htmlContainer: 'swal-custom-content',
        actions: 'swal-custom-actions',
        confirmButton: 'swal-custom-confirm button_primary',
      },
    });
  },

  warning: (title, text) => {
    CustomAlert._injectStyles();
    Swal.fire({
      icon: false,
      title: title || 'Warning',
      text: text || 'Be careful with this action!',
      confirmButtonText: 'OK',
      customClass: {
        popup: 'swal-custom-popup',
        title: 'swal-custom-title',
        htmlContainer: 'swal-custom-content',
        actions: 'swal-custom-actions',
        confirmButton: 'swal-custom-confirm button_primary',
      },
    });
  },

  info: (title, text) => {
    CustomAlert._injectStyles();
    Swal.fire({
      icon: false,
      title: title || 'Information',
      text: text || 'Here is some important information!',
      confirmButtonText: 'OK',
      customClass: {
        popup: 'swal-custom-popup',
        title: 'swal-custom-title',
        htmlContainer: 'swal-custom-content',
        actions: 'swal-custom-actions',
        confirmButton: 'swal-custom-confirm button_primary',
      },
    });
  },

  confirm: (title, text, confirmCallback, cancelCallback, confirmButtonText, cancelButtonText) => {
    CustomAlert._injectStyles();
    Swal.fire({
      icon: false,
      title: title || 'Are you sure?',
      text: text || 'You won’t be able to revert this!',
      showCancelButton: true,
      confirmButtonText: confirmButtonText || 'Yes, confirm!',
      cancelButtonText: cancelButtonText || 'Cancel',
      customClass: {
        popup: 'swal-custom-popup',
        title: 'swal-custom-title',
        htmlContainer: 'swal-custom-content',
        actions: 'swal-custom-actions',
        confirmButton: 'swal-custom-confirm button_primary',
        cancelButton: 'swal-custom-cancel button_secondary',
      },
    }).then((result) => {
      if (result.isConfirmed && confirmCallback) {
        confirmCallback();
      } else if (result.dismiss === Swal.DismissReason.cancel && cancelCallback) {
        cancelCallback();
      }
    });
  },

  confirmAction: ({
    title,
    text,
    confirmBtnText,
    cancelBtnText,
    cancelCallback,
    confirmCallback,
  }) => {
    CustomAlert._injectStyles();
    Swal.fire({
      icon: false,
      title: title || 'Confirmation',
      text: text || 'Are you sure?',
      showCancelButton: true,
      cancelButtonText: cancelBtnText || 'No',
      confirmButtonText: confirmBtnText || 'Yes',
      customClass: {
        popup: 'swal-custom-popup',
        title: 'swal-custom-title',
        htmlContainer: 'swal-custom-content',
        actions: 'swal-custom-actions',
        confirmButton: 'swal-custom-confirm button_primary',
        cancelButton: 'swal-custom-cancel button_secondary',
      },
    }).then((result) => {
      if (result.isConfirmed && confirmCallback) {
        confirmCallback();
      } else if (result.dismiss === Swal.DismissReason.cancel && cancelCallback) {
        cancelCallback();
      }
    });
  },

  confirmExit: (saveCallback, exitWithoutSaveCallback, cancelCallback, texts = {}) => {
    if (!document.getElementById('sweetalert-custom-exit-styles')) {
      const style = document.createElement('style');
      style.id = 'sweetalert-custom-exit-styles';
      style.innerHTML = `
        .swal-exit-popup.swal2-popup {
          border: 1px solid #1A192B !important;
          border-radius: 0px !important;
          padding: 15px !important;
          width: 530px !important;
          background-color: #fff !important;
        }
        .swal-exit-title.swal2-title {
          text-align: left !important;
          color: #002060 !important;
          font-family: 'Poppins', sans-serif !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          padding: 0 !important;
          margin: 0 0 15px 0 !important;
        }
        .swal-exit-content.swal2-html-container {
          text-align: left !important;
          color: #002060 !important;
          font-family: 'Poppins', sans-serif !important;
          font-size: 12px !important;
          margin: 0 0 30px 0 !important;
          padding: 0 !important;
        }
        .swal-exit-actions.swal2-actions {
          width: 100% !important;
          margin: 0 !important;
          padding: 0 !important;
          justify-content: space-between !important;
          display: flex !important;
        }
        .swal-exit-cancel {
            font-size: 11px !important; 
            margin-left: 0; 
            order: 1 !important;
        }
        .swal-exit-deny {
            font-size: 11px !important;
            order: 2 !important;
        }
        .swal-exit-confirm {
            font-size: 11px !important;
            order: 3 !important;
        }
        
      `;
      document.head.appendChild(style);
    }

    Swal.fire({
      title: texts.title || 'You have unsaved changes',
      text: texts.text || 'Do you want to save before exiting?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: texts.confirmButtonText || 'Save & Exit',
      denyButtonText: texts.denyButtonText || 'Exit without saving',
      cancelButtonText: texts.cancelButtonText || 'Cancel',
      confirmButtonColor: '#002060',
      denyButtonColor: '#ee4f55',
      cancelButtonColor: '#002060',
      customClass: {
        popup: 'swal-exit-popup',
        title: 'swal-exit-title',
        htmlContainer: 'swal-exit-content',
        actions: 'swal-exit-actions',
        cancelButton: 'swal-exit-cancel button_secondary order-1 mr_auto',
        denyButton: 'swal-exit-deny button_optional order-2',
        confirmButton: 'swal-exit-confirm button_primary order-3',
      },
    }).then((result) => {
      if (result.isConfirmed && saveCallback) {
        saveCallback(); // Save & Exit
      } else if (result.isDenied && exitWithoutSaveCallback) {
        exitWithoutSaveCallback(); // Exit without saving
      } else if (result.isDismissed && cancelCallback) {
        if (cancelCallback) cancelCallback(); // Just stay on the page
      }
    });
  },

  confirmLanguageSwitch: (saveCallback, dontSaveCallback, texts = {}) => {
    CustomAlert._injectStyles();
    Swal.fire({
      icon: false,
      title: texts.title || 'Save changes before switching language?',
      showCancelButton: true,
      confirmButtonText: texts.confirmButtonText || 'Yes, save & switch',
      cancelButtonText: texts.cancelButtonText || 'No, discard changes',
      customClass: {
        popup: 'swal-custom-popup',
        title: 'swal-custom-title',
        htmlContainer: 'swal-custom-content',
        actions: 'swal-custom-actions',
        confirmButton: 'swal-custom-confirm button_primary',
        cancelButton: 'swal-custom-cancel button_secondary',
      },
    }).then((result) => {
      if (result.isConfirmed && saveCallback) {
        saveCallback(); // User chose to save first
      } else if (result.dismiss === Swal.DismissReason.cancel && dontSaveCallback) {
        dontSaveCallback(); // User chose not to save
      }
    });
  },

  toast: (title, icon = 'success') => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      // didOpen: (toast) => {
      //   toast.onmouseenter = Swal.stopTimer;
      //   toast.onmouseleave = Swal.resumeTimer;
      // }
    });
    Toast.fire({
      icon: icon,
      title: title,
    });
  },
};

export default CustomAlert;
